import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertWebpToJpg() {
  return (
    <ImageConverterTemplate
      sourceFormat="WebP"
      targetFormat="JPG"
      acceptTypes=".webp,image/webp"
      slug="convert-webp-to-jpg"
      gradientColors="from-green-500 to-orange-500"
      accentColor="orange"
      showQualitySlider={true}
    />
  );
}
